if (!customElements.get('collection-grid-toggle')) {
  class CollectionGridToggle extends HTMLElement {
    static VIEW_GRID = 'grid';
    static VIEW_ASYMMETRIC = 'asymmetric';
    static ASYMMETRIC_CLASS = 'collection-grid--asymmetric';
    static ACTIVE_BUTTON_CLASS = 'is-active';
    static STORAGE_KEY = 'collection-grid-view';

    constructor() {
      super();

      this.gridElement = null;
      this.buttons = [];
      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      const { gridSelector, defaultView } = this.dataset;
      if (!gridSelector) return;

      this.gridElement = document.querySelector(gridSelector);
      if (!this.gridElement) return;

      this.buttons = Array.from(this.querySelectorAll('[data-view]'));
      if (this.buttons.length === 0) return;

      for (const btn of this.buttons) {
        btn.addEventListener('click', this.onButtonClick);
      }

      // Set initial view based on saved preference, defaulting to grid view if none or invalid
      this.setView(
        CollectionGridToggle.readStorage() || defaultView || CollectionGridToggle.VIEW_GRID
      );
    }

    disconnectedCallback() {
      for (const btn of this.buttons) {
        btn.removeEventListener('click', this.onButtonClick);
      }
    }

    onButtonClick(event) {
      this.setView(event.currentTarget.dataset.view);
    }

    setView(view) {
      if (!view) return;

      const isAsymmetric = view === CollectionGridToggle.VIEW_ASYMMETRIC;
      this.gridElement.classList.toggle(CollectionGridToggle.ASYMMETRIC_CLASS, isAsymmetric);

      for (const btn of this.buttons) {
        const isActive = btn.dataset.view === view;
        btn.classList.toggle(CollectionGridToggle.ACTIVE_BUTTON_CLASS, isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      }

      try {
        localStorage.setItem(CollectionGridToggle.STORAGE_KEY, view);
      } catch (e) {
        // localStorage may be unavailable (private browsing, quota exceeded)
        // Silently ignore and fall back to the in-memory UI state.
      }

      this.dispatchEvent(new CustomEvent('grid:view-changed', { bubbles: true, detail: { view } }));
    }

    static readStorage() {
      try {
        const value = localStorage.getItem(CollectionGridToggle.STORAGE_KEY);
        const valid = [CollectionGridToggle.VIEW_GRID, CollectionGridToggle.VIEW_ASYMMETRIC];
        return valid.includes(value) ? value : null;
      } catch {
        return null;
      }
    }
  }

  customElements.define('collection-grid-toggle', CollectionGridToggle);
}
